import Cookies from 'js-cookie';
import { CHANGELOGS } from '../data/changelogs';

// Cookie name for storing viewed changelogs
const VIEWED_CHANGELOGS_COOKIE = 'rnr_viewed_changelogs';

// Cookie expiration in days (1 year)
const COOKIE_EXPIRATION = 365;

/**
 * Get the list of changelog versions that the user has already viewed
 * @returns {Array} Array of viewed changelog versions
 */
export const getViewedChangelogs = () => {
  const viewedChangelogsCookie = Cookies.get(VIEWED_CHANGELOGS_COOKIE);
  
  if (!viewedChangelogsCookie) {
    return [];
  }
  
  try {
    return JSON.parse(viewedChangelogsCookie);
  } catch (error) {
    console.error('Error parsing viewed changelogs cookie:', error);
    return [];
  }
};

/**
 * Mark changelogs as viewed by the user
 * @param {Array} changelogVersions - Array of changelog versions to mark as viewed
 */
export const markChangelogsAsViewed = (changelogVersions) => {
  if (!changelogVersions || changelogVersions.length === 0) return;
  
  const currentViewedChangelogs = getViewedChangelogs();
  const updatedViewedChangelogs = [...new Set([...currentViewedChangelogs, ...changelogVersions])];
  
  Cookies.set(
    VIEWED_CHANGELOGS_COOKIE, 
    JSON.stringify(updatedViewedChangelogs), 
    { expires: COOKIE_EXPIRATION, sameSite: 'strict' }
  );
};

/**
 * Get changelogs that have not been viewed by the user
 * @returns {Array} Array of unseen changelog objects
 */
export const getUnseenChangelogs = () => {
  const viewedChangelogs = getViewedChangelogs();
  
  return CHANGELOGS.filter(changelog => 
    !viewedChangelogs.includes(changelog.version)
  );
};

/**
 * Check if there are any unseen changelogs
 * @returns {Boolean} True if there are unseen changelogs
 */
export const hasUnseenChangelogs = () => {
  return getUnseenChangelogs().length > 0;
};
